"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

export type UnifiedPreviewCardProps = {
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
};

export function UnifiedPreviewCard({
  header,
  children,
  className,
  headerClassName,
  bodyClassName,
}: UnifiedPreviewCardProps) {
  return (
    <div className={cn("flex min-h-0 h-full flex-col bg-card", className)}>
      {header ? (
        <header className={cn("border-b border-border", headerClassName)}>
          {header}
        </header>
      ) : null}
      <div className={cn("min-h-0 flex-1", bodyClassName)}>{children}</div>
    </div>
  );
}
